<template>
<div>
  <el-form class="mr-b25" :model="workInfo" :rules="rules" ref="workInfoForm" label-width="120px" label-position="top" @validate="validateForm">
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item label="작업 구분" prop="workTypeId">
          <el-select v-model="workInfo.workTypeId" @change="checkDataChange('workInfo.workTypeId', workInfo.workTypeId)" style="width: 100%;">
            <el-option v-for="item in workTypeDatas" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="작업명" prop="workName">
          <el-input v-model="workInfo.workName" @blur="checkDataChange('workInfo.workName', workInfo.workName)"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="작업 내용" prop="workContents">
      <el-input placeholder="작업내용을 입력해 주십시오." type="textarea" :rows="2" v-model="workInfo.workContents" @blur="checkDataChange('workInfo.workContents', workInfo.workContents)"></el-input>
    </el-form-item>
    <el-row :gutter="10">
      <!-- 공지여부 data는 갖고있어야하므로 v-show -->
      <el-col :span="12" v-show="popupType === 'ADD'">
        <el-form-item label="공지여부" prop="isNotice">
          <el-select v-model="workInfo.isNotice" style="width: 100%;">
            <el-option :label="'공지'" :value="true"></el-option>
            <el-option :label="'미공지'" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="영향도" prop="workImpact">
          <el-select v-model="workInfo.workImpact" @change="checkDataChange('workInfo.workImpact', workInfo.workImpact)" style="width: 100%;">
            <el-option v-for="item in workImpactDatas" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid" />
            <el-option label="영향도 없음" value="GRADE_NULL" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item v-if="popupType === 'ADD'" label="파일등록">
      <el-input v-model="workInfo.fileName" :readonly="true">
        <template slot="append">
          <el-upload :file-list="fileList" :auto-upload="false" :on-change="changeUploadFile" action="" :before-upload="(file) => file" :show-file-list="false">
            <!-- add 1129 btn-upload -->
            <el-button size="small" type="primary" class="btn-upload">파일추가</el-button>
          </el-upload>
        </template>
      </el-input>
    </el-form-item>
  </el-form>
  <el-row type="flex" justify="space-between" class="title-bar">
    <div class="title-h4">작업담당자</div>
    <!-- add 1210 style ie friendly -->
    <el-button style="line-height:31px" size="small" @click="$refs.managerSlidingPopup.open()">작업담당자 등록</el-button>
    <w-manager-list-sliding-popup ref="managerSlidingPopup" :title="`${popupType === 'ADD' ? '작업 추가' : '작업 수정'}`" :manager-list="managerList" @add-manager-list="addManagerList" />
  </el-row>
  <el-table class="mr-b25" :data="managerList" height="160px">
    <el-table-column prop="managerName" label="이름" />
    <el-table-column prop="managerTypeName" label="역할" />
    <el-table-column prop="associationName" label="소속" />
    <el-table-column prop="departmentName" label="부서" />
    <el-table-column prop="mobileNumber" label="모바일" />
  </el-table>
  <div class="title-bar title-h4">유지보수 업체</div>
  <!-- <el-scrollbar style="height: 155px"> -->
  <el-row v-for="(maintenance, index) in maintenanceList" :key="index" type="flex" :gutter="4">
    <el-col :span="6">
      <el-input placeholder="업체명" v-model="maintenance.maintenanceCompany" @change="onInputChange(maintenance, maintenance.maintenanceCompany, 'maintenance.maintenanceCompany', index)"></el-input>
    </el-col>
    <el-col :span="6">
      <el-input placeholder="담당자명" v-model="maintenance.maintenanceManager" @change="onInputChange(maintenance, maintenance.maintenanceManager, 'maintenance.maintenanceManager', index)"></el-input>
    </el-col>
    <el-col :span="12">
      <el-input placeholder="연락처" v-model="maintenance.maintenanceContact" @change="onInputChange(maintenance, maintenance.maintenanceContact, 'maintenance.maintenanceContact', index)"></el-input>
    </el-col>
    <el-col style="width: 34px;">
      <el-button v-if="index === 0" size="mini" @click="addMaintenance()">
        <i class="fas fa-plus" />
      </el-button>
      <el-button v-else size="mini" @click="deleteMaintenance(index)">
        <i class="fas fa-minus" />
      </el-button>
    </el-col>
  </el-row>
  <!-- </el-scrollbar> -->
</div>
</template>

<script>
import { cloneDeep, mapValues } from 'lodash';
import msgUtil from '@/utils/message';
import { isUnauthorizedFile } from '@/utils/file';
import { MSG_UPLOAD_UNAUTHORIZED_FILE } from '@/constants/file';
import WManagerListSlidingPopup from './ManagerListSlidingPopup';

export default {
  name: 'WWorkInfoView',
  components: {
    WManagerListSlidingPopup,
  },
  props: {
    popupType: String,
    workImpactDatas: {
      type: Array,
      default: () => [],
    },
    workTypeDatas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      workInfo: {
        workTypeId: 'CHANGE',
        isNotice: true,
        workImpact: 'GRADE_A',
        fileName: '',
      },
      fileList: [],
      managerList: [],
      maintenanceList: [
        {
          maintenanceCompany: '',
          maintenanceManager: '',
          maintenanceContact: '',
        },
      ],
      rules: {
        workTypeId: [
          {
            required: true,
            message: '작업 구분을 선택해주십시오.',
            trigger: 'change',
          },
        ],
        workName: [
          {
            required: true,
            message: '작업명을 입력해 주십시오.',
            trigger: 'blur',
          },
        ],
        workContents: [
          {
            required: true,
            message: '작업 내용을 입력해 주십시오.',
            trigger: 'blur',
          },
        ],
        isNotice: [
          {
            required: true,
            message: '공지여부를 선택해주십시오.',
            trigger: 'change',
          },
        ],
        workImpact: [
          {
            required: true,
            message: '작업 영향도 선택해주십시오.',
            trigger: 'change',
          },
        ],
      },
      formValid: false,
      originalWorkDatas: {
        workInfo: {},
        managerList: [],
        maintenanceList: [],
      },
      modifiedDataKeys: {
        workInfo: [],
        managerList: false,
        maintenanceList: false,
      },
    };
  },
  methods: {
    /**
     * 파일 업로드 시 데이터 설정 - 비인가 확장자 파일 업로드 불가능 기능 추가
     * @author kimjy -> NaJY
     * @param  {Object} item 파일 정보
     * @return {[type]}      [description]
     */
    changeUploadFile(item) {
      // 비인가 확장자 파일인 경우 업로드 불가능
      if (isUnauthorizedFile(item)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_UNAUTHORIZED_FILE, false));
        return;
      }
      this.workInfo.fileInfo = item.raw;
      this.workInfo.fileName = item.name;
    },
    /**
     * 유지보수 업체 필드 추가
     * @author kimjy
     */
    addMaintenance() {
      this.maintenanceList.push({
        maintenanceCompany: '',
        maintenanceManager: '',
        maintenanceContact: '',
        blankFlag: true,
      });
    },
    /**
     * 유지보수 업체 필드 삭제
     * @author kimjy
     */
    deleteMaintenance(index) {
      this.maintenanceList.splice(index, 1);
      if (this.popupType === 'UPDATE') {
        const modifiedFlag = this.originalWorkDatas.maintenanceList.length !== this.maintenanceList;
        if (modifiedFlag) this.modifiedDataKeys.maintenanceList = true;
      }
    },
    /**
     * 작업 담당자 설정 (관리자 리스트 팝업에서 호출)
     * @author kimjy
     */
    addManagerList(selectedManagerList) {
      this.managerList = selectedManagerList;
      this.modifiedDataKeys.managerList = true;
    },
    /**
     * 설정된 작업 정보 Return (부모 컴포넌트에서 호출)
     * @author kimjy
     * @return {Object} 작업 정보
     */
    getWorkInfo() {
      const resultMap = {
        validatePromise: this.$refs.workInfoForm.validate(),
        workBasicInfo: {
          workInfo: this.workInfo,
          managerList: this.managerList,
          maintenanceList: this.maintenanceList,
        },
      };
      if (this.popupType === 'UPDATE') {
        resultMap.modifiedDataKeys = this.modifiedDataKeys;
      }
      return resultMap;
    },
    validateForm(prop, valid) {
      this.formValid = valid;
    },
    /**
     * 초기 값 설정 (부모 컴포넌트에서 호출) (추가 팝업)
     * @author kimjy
     */
    initWorkInfo() {
      this.$refs.workInfoForm.clearValidate();
      this.workInfo = {
        workTypeId: 'CHANGE',
        isNotice: true,
        workImpact: 'GRADE_A',
        fileName: '',
        workStatus: 'A', // 작업 등록
      };
      this.fileList = [];
      this.managerList = [];
      this.maintenanceList = [
        {
          maintenanceCompany: '',
          maintenanceManager: '',
          maintenanceContact: '',
          blankFlag: true,
        },
      ];

      this.originalWorkDatas = {
        workInfo: cloneDeep(this.workInfo),
        managerList: cloneDeep(this.managerList),
        maintenanceList: cloneDeep(this.maintenanceList),
      };
    },
    /**
     * 작업 data 설정 (부모 컴포넌트에서 호출) (수정 팝업)
     * @author jeee12
     * @param  {[type]} workParams [description]
     */
    loadWorkInfo(workParams) {
      this.$refs.workInfoForm.clearValidate();
      this.workInfo = {
        workTypeId: workParams.workTypeId,
        workName: workParams.workName,
        workContents: workParams.workContents,
        workImpact: workParams.workImpact ? workParams.workImpact : 'GRADE_NULL',
        workStatus: workParams.workStatus,
        isNotice: false,
      };
      if (workParams.noticeSeqNumber) this.workInfo.isNotice = true;

      this.managerList = workParams.managerList;
      if (workParams.maintenanceList.length === 0) {
        this.maintenanceList = [
          {
            maintenanceCompany: '',
            maintenanceManager: '',
            maintenanceContact: '',
            blankFlag: true,
          },
        ];
      } else {
        this.maintenanceList = workParams.maintenanceList;
      }
      this.modifiedDataKeys = {
        workInfo: [],
        managerList: false,
        maintenanceList: false,
      };
      this.originalWorkDatas = {
        workInfo: cloneDeep(this.workInfo),
        managerList: cloneDeep(this.managerList),
        maintenanceList: cloneDeep(this.maintenanceList),
      };
    },
    /**
     * 유지보수 업체 관련 input change
     * @author jeee12
     * @param  {[type]} maintenance [description]
     * @param  {[type]} value       [description]
     */
    onInputChange(maintenance, value, blurTarget, arrIndex) {
      let blankFlagCheck = true;
      mapValues(maintenance, (val, key) => {
        if (key !== 'workSeqNumber' && val !== '') blankFlagCheck = false;
      });

      if (!blankFlagCheck) delete maintenance.blankFlag;
      else maintenance.blankFlag = true;
      this.checkDataChange(blurTarget, value, arrIndex);
    },
    /**
     * data 수정여부 체크
     * @author jeee12
     * @param  {[type]} blurTarget   key 값 (ex. this.workInfo.workName)
     * @param  {[type]} changedValue 변경 value
     */
    checkDataChange(blurTarget, changedValue, arrIndex) {
      const blurData = blurTarget.split('.')[0];
      const blurKey = blurTarget.split('.')[1];
      let originValue;

      if (blurData === 'workInfo') {
        originValue = this.originalWorkDatas[blurData][blurKey];
        if (originValue !== changedValue) this.modifiedDataKeys.workInfo.push(blurKey);
      } else if (blurData === 'maintenance') {
        originValue = this.originalWorkDatas.maintenanceList[arrIndex];
        if (!originValue || originValue[blurKey] !== changedValue) this.modifiedDataKeys.maintenanceList = true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/work/popup/components/WorkInfoView.vue